import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,Form, FormGroup, Label, Button, Modal, ModalHeader, ModalBody
} from "reactstrap";
import { Link } from "react-router-dom";
import Select from 'react-select';
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import TableContainer from "../../../../components/Common/TableContainer";

const OnboardingSelection = () => {
  const [data, setData] = useState([
    { id: 1, name: "Naveen G", email: "naveeng@gmail.com", jobCode: "ARE123", vacancyTitle: "Clerk Test", preExpLevel: "Experienced", nextInterviewer: "", currentStatus: "INPROGRESS" },
    { id: 2, name: "Raman", email: "raman@gmail.com", jobCode: "abc123", vacancyTitle: "Assistant", preExpLevel: "Fresher", nextInterviewer: "", currentStatus: "" },
    { id: 3, name: "Vijay", email: "Vijay@gmail.com", jobCode: "abc123", vacancyTitle: "Assistant", preExpLevel: "Fresher", nextInterviewer: "", currentStatus: "" },
    { id: 4, name: "Divya", email: "divya@gmail.com", jobCode: "QWE123", vacancyTitle: "TIME CHECK", preExpLevel: "Fresher", nextInterviewer: "", currentStatus: "" },
    { id: 5, name: "Dinesh Babu", email: "dinesh@gmail.com", jobCode: "abc123", vacancyTitle: "Assistant", preExpLevel: "Fresher", nextInterviewer: "", currentStatus: "INPROGRESS" },
  ]);

  const statusOptions = [
    { value: "pending", label: "PENDING" },
    { value: "in_progress", label: "IN PROGRESS" },
    { value: "complete", label: "COMPLETE" }
  ];

  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxHeight: 33.1,
      minHeight: 33.1,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px",
    }),
  };

  const columns = [
    {Header: "S.No",className: "serial-no text-center",Cell: ({ row }) => data.length - row.index,},
    { Header: "Name", accessor: "name" },
    { Header: "E-Mail", accessor: "email" },
    { Header: "Job Code", accessor: "jobCode" },
    { Header: "Vacancy Title", accessor: "vacancyTitle" },
    { Header: "Pre Exp Level", accessor: "preExpLevel" },
    { Header: "Status", accessor: "currentStatus", Cell: ({ value }) => <span className="font-weight-bold text-uppercase">{value}</span> },
    {id: "selection",Header: <input type="checkbox" />,className: "serial-no text-center",Cell: ({ row }) => <input type="checkbox" />,}
  ];

const formik = useFormik({
  enableReinitialize: true,
  initialValues: {
    Position: "",
  },
  validationSchema: Yup.object({
    Position: Yup.string().required("Please Enter The Position"),
  }),
  onSubmit: (values) => {
    console.log("Searching for position:", values.Position);
    // You can implement filter logic here if needed.
  },
});

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Onboarding" breadcrumbItem="Onboarding Selection" />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="mb-3 ">
                <Col md="4">
                  <FormGroup>
                    <Label for="Position">
                      Position <span className="text-danger">*</span></Label>
                    <Input
                      name="Position"
                      type="text"
                      value={formik.values.Position}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.Position &&
                        Boolean(formik.errors.Position)
                      }
                    />
                    {formik.touched.Position && formik.errors.Position && (
                      <div className="text-danger">{formik.errors.Position}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="8" className="d-flex mob-center align-items-center justify-content-end mt-4">
                  <Button type="submit" className="btn button-search  btn btn-secondary me-2"><i className="fas fa-search me-1"></i> Search</Button>
                  <Button type="button" className="btn button-cancel" ><i className="fas fa-sync me-1" /> Cancel</Button>
                  </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <div className="d-flex mob-center flex-wrap gap-2 justify-content-end align-items-center mb-3">
                  <Button type="button" className="btn button-save me-2">
                    Send confirmation
                  </Button>

                  <Button type="button" className="btn button-print me-2">
                    Send offer
                  </Button>

                  <Button type="reset" className="btn button-cancel me-2">
                    Send appointment
                  </Button>
                  <Button type="submit" className="btn button-search me-2">
                    Assessment form
                  </Button>
            </div>
            <TableContainer
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              className="custom-table"
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default OnboardingSelection;

